module.exports = __webpack_public_path__ + "static/Color-f7903fcec6a16c7f0cbbfdc83b822d76.webp";